import React from "react";
import SurfaceCard from "../../../Components/Common/SurfaceCard";
import { formatAccount } from "../../../../features/ValueFormater";

function SalesSummaryCard({ currencyLabel, currencyId, loading, value }) {
  return (
    <div className="col-12 col-lg-6">
      <SurfaceCard className="sales-summary-card">
        {loading ? (
          <div className="sales-summary-card__skeleton">
            <div className="sales-summary-card__line sales-summary-card__line--title" />
            <div className="sales-summary-card__line sales-summary-card__line--amount" />
          </div>
        ) : (
          <>
            <div className="sales-summary-card__title">
              Total Sales ({currencyLabel})
            </div>
            <div className="sales-summary-card__amount">
              {formatAccount(value ?? 0, currencyId)}
            </div>
          </>
        )}
      </SurfaceCard>
    </div>
  );
}

export default function SalesSummaryCards({ loading = false, totals = {} }) {
  return (
    <div className="row g-4">
      <SalesSummaryCard
        currencyLabel="USD"
        currencyId={1}
        loading={loading}
        value={totals.USD}
      />
      <SalesSummaryCard
        currencyLabel="LBP"
        currencyId={2}
        loading={loading}
        value={totals.LBP}
      />
    </div>
  );
}
